import React from 'react';
import { Platform, View, ViewProps } from 'react-native';

interface IProtectedImageContainerProps extends ViewProps {
  children: React.ReactNode;
}

const protectedImageClassName =
  'web:select-none web:[&_img]:pointer-events-none web:[&_img]:select-none web:[&_img]:[-webkit-user-drag:none]';

export function ProtectedImageContainer({
  children,
  className,
  ...props
}: IProtectedImageContainerProps) {
  const webProps =
    Platform.OS === 'web'
      ? ({
          onContextMenu: (event: React.MouseEvent) => event.preventDefault(),
          onDragStart: (event: React.DragEvent) => event.preventDefault(),
        } as any)
      : undefined;

  return (
    <View
      {...props}
      {...webProps}
      className={[protectedImageClassName, className].filter(Boolean).join(' ')}>
      {children}
    </View>
  );
}
